import { render, staticRenderFns } from "./PluginConfiguration.vue?vue&type=template&id=76af74b1"
import script from "./PluginConfiguration.vue?vue&type=script&lang=ts"
export * from "./PluginConfiguration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports